module.exports = fox._r("images/hd.png", __webpack_public_path__ + "images/hd.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/hd.png
// module id = 1054
// module chunks = 4